import request from '@/api/request.js'
export function pageList(data, page) {
  return request({
    url: '/publicOpinionFindings/pageList?' + `pageSize=${page.pageSize}&pageNum=${page.pageNum}`,
    method: 'post',
    data: data
  })
}
export function loadReport(data) {
  return request({
    url: '/reportTask/load?reportId=' + data.reportId,
    method: 'get',
  })
}

export function deleteReport(data) {
  return request({
    url: '/reportTask/delete?reportId=' + data.reportId,
    method: 'get',
  })
}
export function insert(data) {
  return request({
    url: 'reportTask/insert',
    method: 'post',
    data: data
  })
}
export function update(data) {
  return request({
    url: '/reportTask/update',
    method: 'post',
    data: data
  })
}

//研判记录
export function auditList(data,page) {
  return request({
    url: '/publicOpinionFindings/auditList?' + `pageSize=${page.pageSize}&pageNum=${page.pageNum}`,
    method: 'post',
    data: data
  })
}
//研判记录审核人员
export function allAuditor() {
  return request({
    url: '/publicOpinionFindings/allAuditor',
    method: 'get'
  })
}

//导出
export function exportReportTask(data) {
  return request({
    url: '/reportTask/exportReportTask',
    method: 'post',
    responseType: "blob",
    data: data
  })
}

export default {
  pageList,
  insert,
  deleteReport,
  loadReport,
  update,
  auditList,
  allAuditor,
  exportReportTask
}